import { useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentApi } from '../services/paymentApi';
import type { CreateQuickInvoiceRequest } from '../types/payments';
import { useHybridAuth } from './useHybridAuth';

export function useCreateQuickInvoice(companyId: string | undefined) {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useHybridAuth();

  return useMutation({
    mutationFn: async (data: CreateQuickInvoiceRequest) => {
      if (!companyId) {
        throw new Error('Company ID is required');
      }
      const token = await getAccessTokenSilently();
      return paymentApi.createQuickInvoice(data, companyId, token);
    },
    onSuccess: (_, variables) => {
      // Invalidate payment status cache
      queryClient.invalidateQueries({
        queryKey: ['payment-status', variables.dispatchId, companyId],
      });
      paymentApi.clearCache(variables.dispatchId);
    },
  });
}

